export default "__VITE_ASSET__22a9e9fb__"